<div class="card shadow-none border-0">
  <div class="card-body pt-2">
    <div class="row mt-2 mb-4">
      <div class="col-10">
        <span class="nav-font18 nav-secondary font-weight-bold"><i class="fal fa-triangle-exclamation mr-2"></i>Confirm shared note</span>
      </div>
      <div class="col d-flex align-items-center justify-content-end">
        <i class="fas fa-close cursor-pointer grey4" (click)="closeModal()"></i>
      </div>
    </div>

    <p class="nav-font14 grey5 mb-4 mx-4">
      This note is visible to all vendors. To edit or delete it, go to the Notes section in the left-hand menu.
    </p>

    <div class="d-flex align-items-center justify-content-end">
      <span type="button" class="btn btn-sm nav-btn-primary shadow-none font-weight-bold"
        (click)="cancel()">Cancel</span>
      <span type="button" class="btn ml-2 btn-sm nav-btn-accent shadow-none font-weight-bold"
        (click)="save()">Confirm</span>
    </div>

  </div>
</div>

